import { Capacitor } from '@capacitor/core'
import { App, AppInfo } from '@capacitor/app'

let _version = ''

export async function getAppVersion (): Promise<string> {
  if (!_version) {
    let info: AppInfo | undefined
    if (Capacitor.isNativePlatform()) {
      info = await App.getInfo()
    }

    let version = ''
    if (info?.version) {
      version = info.version
    } else {
      version = process.env.VUE_APP_VERSION || '0.0.0'
    }
    _version = trimVersion(version)
  }

  return _version
}

export function trimVersion (v: string | undefined): string {
  if (v) {
    if (v[0] === 'v') {
      return v.slice(1)
    } else {
      return v
    }
  } else {
    return ''
  }
}
